import React, { Component } from "react";
import Routes from "./Routes";
import { Spin, Layout } from "antd";
import { AxiosGetSecretApi } from "./utils/fetchApi";
import { LocalStore } from "./utils/LocalStore/index";

import { library } from "@fortawesome/fontawesome-svg-core";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIgloo } from "@fortawesome/free-solid-svg-icons";
import { isIOS, isAndroid, isTablet } from "react-device-detect";
import "antd/dist/antd.css";
import "./App.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "react-widgets/dist/css/react-widgets.css";
import "react-toastify/dist/ReactToastify.css";
import "filepond/dist/filepond.min.css";
import "ol/ol.css";
import "react-select/dist/react-select.css";
import "react-virtualized/styles.css";
import "react-virtualized-select/styles.css";

import "./assets/map.scss";
import "./assets/overwrite-antd.scss";
import "./assets/style-all.scss";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import "react-checkbox-tree/src/less/react-checkbox-tree.less";
import "react-checkbox-tree/src/scss/react-checkbox-tree.scss";

//-----redux-----//
import { connect } from "react-redux";
import { getDataAuth } from "./redux/actions/auth.action";
//--------------//
library.add(faIgloo);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false,
      permission: undefined
    };
  }
  componentDidMount = async() =>{
    // console.log('okk', isIOS)
    if (isIOS && !isTablet) {
      window.location =
        "https://apps.apple.com/vn/app/ttqh-%C4%91%C3%A0-n%E1%BA%B5ng/id1559033028?ign-itscg=30200&ign-itsct=apps_box_link#?platform=iphone";
    } else if (isAndroid) {
      window.location =
        "https://play.google.com/store/apps/details?id=com.ttqhSoXayDung";
    }
    if (LocalStore.getInstance().read("loginSession")) {
      //lưu lại redirectUrl
      try {
        let data = await AxiosGetSecretApi("/api/users/verifytoken");

        if (!data.login) {
          LocalStore.getInstance().save("loginSession", null);
          LocalStore.getInstance().save("loginRole", null);
        } else {
          // ---------------------------------- set again local storage
          LocalStore.getInstance().save("loginRole", data.role);
          LocalStore.getInstance().save("HoVaTen", data.HoVaTen);

          LocalStore.getInstance().save("loginPermission", data.Permistion);
          LocalStore.getInstance().save("loginListRole", data.ListQuyen);
          data.MaPhuongXa &&
            LocalStore.getInstance().save("loginMaPhuongXa", data.MaPhuongXa);
          LocalStore.getInstance().save("id", data.Id);
          this.setState({
            permission: data.Permistion
          })
        }
        this.setState({ isChecked: true,});
        // this.props.history.push('/dang-nhap');
      } catch (e) {
        // console.error(e);
        LocalStore.getInstance().save("loginSession", null);
        LocalStore.getInstance().save("loginRole", null);
        this.setState({ isChecked: true });
      }

      // if (window.location.hash && window.location.hash.indexOf('#/authentication') < 0) {
      //     LocalStore.getInstance().save('redirectUrl', window.location.href);
      // }
    } else {
      await AxiosGetSecretApi("/api/users/form");
      this.setState({ isChecked: true });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if(prevState.permission !== this.state.permission){
      this.props.getAuthData(this.state.permission)
    }
  }

  render() {
    if (this.state.isChecked) {
      return (
        <div id={"app-main"} className="{App}">
          {!((isIOS && !isTablet) || isAndroid) && <Routes />}
        </div>
      );
    } else {
      return (
        <Layout
          style={{
            height: "100vh",
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* <Spin indicator={<Icon type={"loading"} />} /> */}
          <Spin></Spin>
          <span>loading</span>
        </Layout>
      );
    }
  }
}

// export default App;

const mapStateToProps = (state) => {
  return {
    isSocket: state.socket.isSocket,
    isShowMapLayer: state.menu.isShowMapLayer,
    permission: state.auth.permission
  };
};

const mapDispatchToProps = {
  getAuthData: getDataAuth
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
